import "../../utils/tailwind.css";
import Dropdown from "react-bootstrap/Dropdown";
import Input from "../input";
import FillArrow from "../svg/fill-arrow";
import cx from "../../utils/tailwind-merge";
import FormError from "../form-error";
import { useField, useFormikContext } from "formik";
import { useState } from "react";

export default function DropdownComponent(props) {
  const { options = [], value, onChange, inputClassName = "", rootClassName = "", menuItemClassName } = props;
  const [showDropdown, setShowDropdown] = useState(false);

  const handleSelect = (selectedValue) => {
    onChange(selectedValue);
    setShowDropdown(false);
  };

  const getRightIcon = () => {
    return (
      <div className="absolute right-3 top-[24px] transform -translate-y-1/2 text-gray-400 !cursor-pointer">
        <FillArrow className={cx(showDropdown && "rotate-180")} />
      </div>
    );
  };

  return (
    <Dropdown className={cx(rootClassName)} show={showDropdown} onToggle={(isOpen) => setShowDropdown(isOpen)}>
      <div role="button" tabIndex={0} className="w-full cursor-pointer" onClick={() => setShowDropdown(!showDropdown)}>
        <Input
          ootClassName="w-full"
          className={cx("!bg !pl-2 cursor-pointer", inputClassName)}
          value={options.find((item) => item.value === value)?.label || ""}
          rightIcon={getRightIcon()}
          placeholder="Select"
          readOnly
          rootClassName="w-full"
        />
      </div>

      <Dropdown.Menu className="!bg-white w-full">
        {options.map((item, index) => (
          <Dropdown.Item
            key={index}
            role="button"
            tabIndex={0}
            className={cx("!bg-transparent !text-black", item.value === value && "!bg-[#EBEAF7] !text-[#393188]", menuItemClassName)}
            onClick={() => handleSelect(item.value)}
          >
            <div className="flex justify-between items-center">
              {item.label}
              {item?.no && <div>{item.no}</div>}
            </div>
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );
}

export function FormikDropdown(props) {
  const { name, classNames = {}, onChange, ...restProps } = props;
  const [field, meta, { setValue }] = useField(name);
  const { submitCount } = useFormikContext();

  const isError = submitCount > 0 && !!meta.error;
  const helperText = (submitCount > 0 && meta.error) || "";

  const handleChange = (selectedValue) => {
    setValue(selectedValue);
    onChange && onChange(selectedValue);
  };

  return (
    <>
      <DropdownComponent {...field} {...restProps} value={field.value} onChange={handleChange} error={isError} />
      <FormError show={isError} message={helperText} className={classNames.error} />
    </>
  );
}
